<script setup lang="ts">
interface ErrorBannerProps {
  isError: boolean;
  error: string | null;
}
const props = defineProps<ErrorBannerProps>();
</script>

<template>
  <div v-if="props.isError">
    <q-banner rounded class="text-white bg-red">
      {{ props.error }}
    </q-banner>
  </div>
</template>
